import React, {useEffect} from "react";
import * as omnimap from "../../../../../../api/omnimap/omnimapActions";
import BulkUpdateSingleRow from "./bulkUpdateSingleRow";
import BulkUpdateEdit from "./bulkUpdateEdit";

class BulkUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      rows : [],
      isInDetail: false,
      clickedID:0
    };
    this.baseState = this.state;

    this.nonStateRows = [];

    this.onDetailClick = (id) => {
      this.setState({
        clickedID: id,
        isInDetail:true
      })
    };

    this.onPopUpClose = () => {
      this.setState({
        isInDetail:false
      })
    };

    this.handleSwitchCondition = () => {
      if(!this.state.isInDetail){
        return this.getAllRows()
      }
      else {
        // Make onClose function global to reach from BulkUpdateEdit component
        window.$mm_schedule_bulkUpdateDetailOnClose = this.onPopUpClose;
        return <BulkUpdateEdit {...this.state.rows[this.state.clickedID]}/>
      }
    }
  };


  getAllRows = function () {
    let returnVal = [];
    window.$mm_schedule_bulkUpdateNonStateRows = [];

    this.state.rows.forEach((row, index) => {
      // Check if the field is active
      if(row.visible){
        // Add id for each row
        row.rowId = index;
        // Set, onClick function for each row
        row.onClick = this.onDetailClick;
        // Handle single row and push to an array
        returnVal.push(<BulkUpdateSingleRow {...row}/>);
        // Create a copy of rows that can be reach globally
      }
    });
    // Return a full of component array
    return returnVal;
  }

  getFields() {
    omnimap.GetFreeFormatByIdAction(process.env.REACT_APP_SETTING_WERKREGELS)
        .then((res) => {
          this.setState({
            // Set the rows with extra fields information.
            rows : res.data[0].data.aliases
          })
        })
        .catch((err) => alert(err));
  }

  async componentDidMount() {

    // Get fields on load
    this.getFields();
  };

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="bulk_update_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Bulkbeheer</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={window.$mm_schedule_bulkUpdateDetailOnClose}
              />
            </div>
            <div className="modal-bulk-body">
              <table
                  id="bulkTable"
                  className="table-hover table min-full-width dataTable no-footer"
                  aria-describedby="example_info"
                  role="grid"
                  style={{width: '100%'}}

              >
                <tbody>
                <td/>
                {
                  this.handleSwitchCondition()
                }
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default BulkUpdate;
